export class MessageRemoteRepository {
    constructor(fetcher) {
        this.fetcher = fetcher;
    }
    async addMessage(message) {
        const request = MessageRemoteRepository.mapMessageToRequest(message);
        const response = await this.fetcher.fetchPostJson(MessageRemoteRepository.MESSAGES_PATH, request);
        return MessageRemoteRepository.mapResponseToMessage(response);
    }
    static mapMessageToRequest(message) {
        return {
            id: message.id,
            conversationId: message.conversationId,
            authorId: message.authorId,
            type: message.type,
            text: message.text,
            createDate: message.createDate,
            serverReceiveDate: message.serverReceiveDate,
            firstClientSendDate: message.firstClientSendDate,
            receiveDate: message.receiveDate,
            readDate: message.readDate
        };
    }
    static mapResponseToMessage(response) {
        return {
            id: response.id,
            conversationId: response.conversationId,
            authorId: response.authorId,
            type: response.type,
            text: response.text,
            createDate: new Date(response.createDate),
            serverReceiveDate: response.serverReceiveDate ? new Date(response.serverReceiveDate) : undefined,
            firstClientSendDate: response.firstClientSendDate ? new Date(response.firstClientSendDate) : undefined,
            receiveDate: response.receiveDate ? new Date(response.receiveDate) : undefined,
            readDate: response.readDate ? new Date(response.readDate) : undefined
        };
    }
}
MessageRemoteRepository.MESSAGES_PATH = '/api/messages';
